export const CONVERSION_TOOL_COLUMNS_RESET = 'CONVERSION_TOOL_COLUMNS_RESET';

export const CONVERSION_TOOL_COLUMNS_FETCH_START = 'CONVERSION_TOOL_COLUMNS_FETCH_START';
export const CONVERSION_TOOL_COLUMNS_FETCH_SUCCESS = 'CONVERSION_TOOL_COLUMNS_FETCH_SUCCESS';
export const CONVERSION_TOOL_COLUMNS_FETCH_FAILURE = 'CONVERSION_TOOL_COLUMNS_FETCH_FAILURE';

export const CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_START =
  'CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_START';
export const CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_SUCCESS =
  'CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_SUCCESS';
export const CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_FAILURE =
  'CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_FAILURE';

export const CONVERSION_TOOL_SET_MAPPING_COLUMNS = 'CONVERSION_TOOL_SET_MAPPING_COLUMNS';
